import getImageUrl from './getImageUrl'

const itemFormatting = {
	title: item => `${item.itemName.indexOf(item.brandName) === -1 ? `${item.brandName} ` : ''}${item.itemName}${item.variation ? ` ${item.variation.join(' ')}` : ''}`,
	image: item => (item.colour && item.colour.images ? getImageUrl(item.colour.images.half) : '/images/placeholder.png')
}

export default itemFormatting



// WEBPACK FOOTER //
// ./src/utilities/itemFormatting.js